import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./navbar/Navbar";
import MobileNav from "./navbar/MobileNav";
import NotificationToaster from "../notifications/NotificationToaster";
import styles from './MainLayout.module.css';
import AuthContext from "../../context/AuthContext";
import GraphBackground from "./body/GraphBackground";

const MainLayout = ({ children }) => {
    const location = useLocation();
    const { loggedIn } = useContext(AuthContext);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 900);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const displayNavbar = !["/login", "/", "/register", "/authenticate", "/forgot-password", "/reset-password"].includes(location.pathname) &&
                            !location.pathname.startsWith("/create");

    return (
        <div className={styles.mainContainer}>
            {displayNavbar && (isMobile ? <MobileNav /> : <Navbar />)}
            {/* Where the bell badge can't signal, live notifications surface as toasts. */}
            {!displayNavbar && <NotificationToaster />}
            <div
                className={`${styles.bodyContainer} ${!displayNavbar ? styles.noNavbar : ''}`}
            >
                {children}
            </div>
        </div>
    );
};

export default MainLayout;
